import { postDataPromise } from 'brock-fetch-utils';
import PerformanceUtils from './performanceUtils';

export function handleErrorResult(error, setError) {
    if (error.httpResult) {
        error.httpResult.json().then((httpResultBody) => {
            setError(httpResultBody);
        });
    } else {
        setError(error);
    }
}

export function metricDataPromise(uri, payload) {
    return postDataPromise(uri, payload);
}

export function getMetricData(
    uri,
    payload,
    setError
) {
    const performanceHandle = PerformanceUtils.markPerformanceStart(
        'getMetricData'
    );

    return metricDataPromise(uri, payload).then(
        (response) => {
            PerformanceUtils.getPerformanceMeasure(performanceHandle);
            PerformanceUtils.logStats();
            return response;
        },
        (error) => {
            handleErrorResult(error, setError);
            return null;
        }
    );
}
